import { render } from "./DrPrakashParimal.vue?vue&type=template&id=ee002d0a"
import script from "./DrPrakashParimal.vue?vue&type=script&lang=js"
export * from "./DrPrakashParimal.vue?vue&type=script&lang=js"

import "./DrPrakashParimal.vue?vue&type=style&index=0&id=ee002d0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__